
<mat-card>

  <mat-card-content>
    <p>Signing out...</p>
  </mat-card-content>
  
</mat-card>

